// TouchPoint types (mirrors backend DTOs for Email, Phone, Social, SMS, Meeting campaigns)
export var TouchPointType;
(function (TouchPointType) {
    TouchPointType["Email"] = "Email";
    TouchPointType["Phone"] = "Phone";
    TouchPointType["Social"] = "Social";
    TouchPointType["Meeting"] = "Meeting";
})(TouchPointType || (TouchPointType = {}));
// EmailSendRule — structured timing config for email touchpoints.
// Either an absolute send time (Kind=Scheduled) or an event-anchored offset (Kind=Event).
export var EmailSendRuleKind;
(function (EmailSendRuleKind) {
    EmailSendRuleKind["Scheduled"] = "Scheduled";
    EmailSendRuleKind["Event"] = "Event";
})(EmailSendRuleKind || (EmailSendRuleKind = {}));
export var EmailOffsetUnit;
(function (EmailOffsetUnit) {
    EmailOffsetUnit["Minute"] = "Minute";
    EmailOffsetUnit["Hour"] = "Hour";
    EmailOffsetUnit["Day"] = "Day";
})(EmailOffsetUnit || (EmailOffsetUnit = {}));
// Wire values match the API's EnumExtensions.ToDescription() output
// (the codebase-wide convention for enum serialization).
export var EmailEventType;
(function (EmailEventType) {
    EmailEventType["WebRegistered"] = "Web Registered";
    EmailEventType["OnlineEventStart"] = "Online Event Start";
    EmailEventType["OnlineEventEnd"] = "Online Event End";
    EmailEventType["AssetDownloaded"] = "Asset Downloaded";
    EmailEventType["MeetingBooked"] = "Meeting Booked";
    EmailEventType["DemoBooked"] = "Demo Booked";
})(EmailEventType || (EmailEventType = {}));
export const TOUCHPOINT_TYPE_LABELS = {
    Email: 'Email',
    Phone: 'Call',
    Social: 'Social Post',
    Meeting: 'Meeting',
};
export const TOUCHPOINT_TYPE_ICONS = {
    Email: '📧',
    Phone: '📞',
    Social: '📱',
    Meeting: '🤝',
};
